/**
 * @generated SignedSource<<9b52dfa56513d3a5280baa94d980c09a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type storyStyleCardArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"imageStoryStyleCardImageArticle" | "linkStoryStyleCardLinkArticle" | "titleStoryStyleCardTitleArticle">;
  readonly " $fragmentType": "storyStyleCardArticle";
};
export type storyStyleCardArticle$key = {
  readonly " $data"?: storyStyleCardArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"storyStyleCardArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "storyStyleCardArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "imageStoryStyleCardImageArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "titleStoryStyleCardTitleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "linkStoryStyleCardLinkArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "c282d5dca9b590e945a38b802f0ea14e";

export default node;
